/**
 * @param {{ activo?: boolean; disponibleCompra?: boolean; disponibleParaCompra?: boolean } | null | undefined} course
 */
export function isCourseAvailableForPurchase(course) {
  if (!course) return false;
  if (course.activo === false) return false;
  if (course.disponibleParaCompra === false) return false;
  // undefined disponibleCompra is treated as available (catalog default from API).
  return course.disponibleCompra !== false;
}

/**
 * @param {{ activo?: boolean; disponibleCompra?: boolean; disponibleParaCompra?: boolean } | null | undefined} course
 */
export function isCourseComingSoon(course) {
  if (!course) return false;
  if (course.activo === false) return false;
  return course.disponibleCompra === false;
}
